import { create } from 'zustand';
 
interface LoginStatus {
  isLogin: boolean;
  userMobile: string;
  useruuId: string; // Change userId to useruuId
  setIsLoginStatus: (status: boolean) => void;
  clearIsLoginStatus: () => void;
  setUserMobile: (mobile: string) => void;
  clearUserState: () => void;
  setUseruuId: (id: string) => void; // Change setUserId to setUseruuId
  clearUseruuId: () => void; // Change clearUserId to clearUseruuId
}
 
const useLoginStatusStore = create<LoginStatus>((set) => ({
  isLogin: false,
  userMobile: '',
  useruuId: '', // Initialize useruuId with an empty string
 
  setIsLoginStatus: (status) =>
    set(() => ({
      isLogin: status,
    })),
 
  clearIsLoginStatus: () =>
    set(() => ({
      isLogin: false,
    })),
 
  setUserMobile: (mobile) =>
    set(() => ({
      userMobile: mobile,
    })),
 
  clearUserState: () =>
    set(() => ({
      isLogin: false,
      userMobile: '',
      useruuId: '', // Clear useruuId as well
    })),
 
  setUseruuId: (id) =>
    set(() => ({
      useruuId: id, // Set the useruuId
    })),
 
  clearUseruuId: () =>
    set(() => ({
      isLogin: false,
      useruuId: '', // Clear useruuId
    })),
}));
 
export default useLoginStatusStore;
 
 